const itemsCartSummaryPopup2 = document.getElementById('items-cart-pop-up');
const priceWithDiscountCartPopUp2 = document.getElementById('price-with-discount-cart-pop-up');
const priceWithoutDiscountCartPopUp2 = document.getElementById('price-without-discount-cart-pop-up');
const modalCheckoutRedirect2 = document.querySelector('modal-checkout');
const iconCartHeader = document.getElementById('cart-icon-bubble');
const btnOpenPopUpDrawer = document.getElementById('CartDrawer');
const mainContainerPages2 = document.getElementById('main-container-pages');

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
    this.openCheckout(modalCheckoutRedirect2);
    this.openCartDrawer();
  }

  getCart = async () =>{
      const responseCart = await fetch("/cart.json");
      return await responseCart.json();
  }

  openCartDrawer = () => {
    iconCartHeader?.addEventListener('click', async (event) => {
      const currentCart = await this.getCart();
      this.showSummaryModal(currentCart);
    });
  }

  openCheckout = (modalCheckoutRedirect) => {
    btnOpenPopUpDrawer?.addEventListener('click', async (event) => {
        //event.preventDefault();
        if(event.target.matches('#CartDrawer-Checkout')){
          const currentCart = await this.getCart();
          modalCheckoutRedirect.style.display = "flex";  
          mainContainerPages.classList.add("overflow-hidden-main-structure");
          this.showSummaryModal(currentCart);
        }
    });
  }

  getFormatForCountry = (value, country) => {
      console.log(value);
      let valueReturn = "";
      switch (country) { 
         case "CO":
            valueReturn = "$ " + this.formatMoneyCart(value, "amount");
            break;
         case "GT":
            valueReturn = "Q " + this.formatMoneyCart(value, "amount");
            break;
      }
      
      return valueReturn;
  }

  formatWithDelimiters = (number, precision, thousands, decimal) => {
        thousands = thousands || ',';
        decimal = decimal || '.';
  
        if (isNaN(number) || number === null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : '';
  
        return dollarsAmount + centsAmount;
  }

  formatMoneyCart = (cents, format) => {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format;
  
      return this.formatWithDelimiters(cents, 0);
  }

  structureItemsPopUp = (items) => {
      let structure = "";
      for(let i = 0; i < items.length; i++){
        structure += '<a class="item-cart-summary-popup" href="'+items[i].url+'"><div class="image-cart-summary-popup"><img src="'+
          items[i].featured_image.url+'"/></div><div class="info-item-cart-summary-popup"><span class="title-item-cart-pop-up">'+
          items[i].title.split("-")[0].trim()+'</span><span class="price-item-cart-pop-up">'+
          this.getFormatForCountry(items[i].price, metafieldCurrentCountry)+'</span><span class="variant-item-cart-pop-up">Talla: '+
          items[i].variant_options[0]+" / "+items[i].variant_options[1]+'</span><span class="cant-item-cart-pop-up">Cant: '+
          items[i].quantity+'</span></div></a>'
      }
      return structure
  }

  showSummaryModal = async (currentCart) => {
    console.log(currentCart);
    itemsCartSummaryPopup2.innerHTML = this.structureItemsPopUp(currentCart.items);
    priceWithDiscountCartPopUp2.innerHTML = this.getFormatForCountry(currentCart.total_price, metafieldCurrentCountry); 
    priceWithoutDiscountCartPopUp2.innerHTML = currentCart.total_discount > 0 ? this.getFormatForCountry(currentCart.original_total_price, metafieldCurrentCountry): "";
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceQty = html.querySelector("cart-items");
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.showSummaryModal(parsedState);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
          // update cart item count in PDP
          if (section.id == "cart-icon-bubble") {
            var buyBtnNumberEl = document.querySelector(
              ".rocket-scalpers-main-product__buy-buttons-menu-number"
            );
            var itemCountStr =
              elementToReplace.querySelector(".cart-item_count").innerText;
            if (buyBtnNumberEl) {
              if (itemCountStr == "0") {
                buyBtnNumberEl.classList.add("hidden");
              }
              buyBtnNumberEl.innerText = itemCountStr;
            }
          }
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });

        // console.log(parsedState);
        // document.dispatchEvent(new Event("listencart", { value: parsedState }));
        var listencart = new CustomEvent("listencart", {
          value: parsedState,
        });
        document.dispatchEvent(listencart);
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
